import { mapGetters } from 'vuex'

import ygcd_icon from 'Assets/images/car/carType/2000018.png'
import cccx_icon from 'Assets/images/car/carType/2000019.png'
import sqyc_icon from 'Assets/images/car/carType/2000020.png'
import default_icon from 'Assets/images/login/logo76x76.png'
import { metreToKm } from '@/business/utils/string'

export default {
  filters: {
    icon(val) {
      const obj = {
        '2000018': ygcd_icon,
        '2000019': cccx_icon,
        '2000020': sqyc_icon
      }
      return obj[val] || default_icon
    },
    type(info) {
      let arr = ['接机', '送机', '接站', '送站', '包车']
      if (arr[info]) {
        return arr[info]
      }
      return ''
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      carSearchInfo: 'car/carSearchInfo',
    }),
    // 开启了用车月结 才可以预订
    async UseAccount_DebtYck () {
      if(
        (this.userInfo.empInfo.useAccountStr &&
          this.userInfo.empInfo.useAccountStr.indexOf($dict.PRO_TYPE.car) > -1) ||
        this.userInfo.empInfo.useAccount == 1
      ) {

        if(
          (this.userInfo.vipCorp.ifDebt &&
            this.userInfo.vipCorp.ifDebt.indexOf($dict.ORDER_TYPE.car) > -1) ||
          (this.userInfo.vipCorp.ifYck &&
            this.userInfo.vipCorp.ifYck.indexOf($dict.ORDER_TYPE.car) > -1)
        ) {
          return true
        }
      }

      // 产品设置  未开启月结时 是否能在线预订
      const {data: UseByMonth = {}} = await this.$api['common/getSysParameter']({
        paramNo: '11604003'
      })

      if(UseByMonth.value2 == '1') {
        return true
      }

      return false
    }
  },
  /**
   * VehiclesClzcMatchResponse {
      cityLevelCode (string): 适用规则 1预估价格 2里程
      wjMonths (string, optional): 适用日期（周几） 多个,分割
      kysd (string, optional): 可用时段
      sfwb (string): 是否违背0否1是
      clzcValue (string): 差旅标准值
      gkfs (integer): 管控方式1只做提醒2不允许预订
    }
   */
  methods: {
    getUseTypeBylocaltype (type) {
      const E_Type = {
        4: { label: '日包', value: '1' },
        // 5: { label: '半日包', value: '2' },
        0: { label: '接机', value: '4' },
        1: { label: '送机', value: '5' },
        2: { label: '接站', value: '6' },
        3: { label: '送站', value: '7' },
        5: { label: '即时用车', value: '8' },
        // 6: { label: '预约用车', value: '9' },
      }

      if (type == 4 && this.carSearchInfo.useDays === 0.5) {
        return '2'
      }

      let useType = E_Type[type].value

      return useType
    },
    iswb (priceDetail) {
      if (priceDetail.clzcMatch) {
        const ClzcMatch = priceDetail.clzcMatch
        if (ClzcMatch.sfwb === '1') {
          return true
        }
      }

      return false
    },
    canbook (priceDetail) {
      if (this.iswb(priceDetail) && priceDetail.clzcMatch) {
        const ClzcMatch = priceDetail.clzcMatch
        if (ClzcMatch.gkfs === 2) {
          return false
        }
      }

      return true
    },
    genViolateDesc (priceDetail) {
      if (priceDetail.clzcMatch) {
        const ClzcMatch = priceDetail.clzcMatch

        if (ClzcMatch.cityLevelCode === '1') {

          return `预估价格不得高于${ClzcMatch.clzcValue}元`

        } else if (ClzcMatch.cityLevelCode === '2') {

          return `里程不得高于${ClzcMatch.clzcValue}公里，当前预计里程${metreToKm(priceDetail.distance)}公里`

        }
      }
    },
  }
}
